/** Результата нет: блок не оценён, а итог не сложился ни в балл, ни в значение */
export const EMPTY_RESULT = '—';

/**
 * Результат блока или итога заключения в том виде, в каком он получен: балл со своим максимумом
 * и размерностью либо значение справочника, у которого ни максимума, ни размерности нет.
 */
export type ExpertReportResult = {
  /** Балл; `null` — результат не балл */
  score?: number | null;
  /** Максимальный балл */
  maxScore?: number | null;
  /** Значение справочника; исключает балл */
  value?: string | null;
  /** Размерность балла */
  unit?: string | null;
};

/** Балл с максимумом и размерностью, если она определена */
export const formatScoreWithUnit = (score: number, maxScore: number | null | undefined, unit?: string | null): string =>
  `${score} / ${maxScore ?? 0}${unit ? ` ${unit}` : ''}`;

/** Балл с размерностью, если она определена, — без максимума */
export const formatScore = (score: number | string, unit?: string | null): string =>
  `${score}${unit ? ` ${unit}` : ''}`;

/**
 * Текст результата; `null` — результата нет.
 * Значение справочника печатается само по себе, балл — с размерностью, но без максимума:
 * максимум сам по себе результатом не является и место занимает зря.
 *
 * Как печатается сам балл, задаёт `formatScoreValue`: правило показа результата у всех
 * потребителей одно, а вид числа у каждого свой (в таблице дашборда — с одним знаком после
 * запятой). Не-число баллом не считается: показывать нечего.
 */
export const getExpertReportResultText = (
  { score, value, unit }: ExpertReportResult,
  formatScoreValue: (score: number) => string = String,
): string | null => {
  if (value != null) return value;
  if (score == null || Number.isNaN(score)) return null;
  return formatScore(formatScoreValue(score), unit);
};
